import { render } from "./BookableCard.vue?vue&type=template&id=65912808&scoped=true"
import script from "./BookableCard.vue?vue&type=script&lang=js"
export * from "./BookableCard.vue?vue&type=script&lang=js"

import "./BookableCard.vue?vue&type=style&index=0&id=65912808&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65912808"]])

export default __exports__